import { render, staticRenderFns } from "./ScrollWrapper.vue?vue&type=template&id=f43cc204"
import script from "./ScrollWrapper.vue?vue&type=script&lang=js"
export * from "./ScrollWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports